import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import {
  Alert,
  Box,
  Button,
  FormControl,
  Modal,
  Snackbar,
  TextField,
  Typography,
  Card,
  InputAdornment,
  Grid
} from '@mui/material';
import React from 'react';
import { Label } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
  textStyleKey: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    textAlign: 'left',
    color: '#000000',
    opacity: '0.5',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  },
  textStyleValue: {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '20px',
    textAlign: 'left',
    color: '#000000',
    opacity: '0.5',
    textTransform: 'capitalize',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    }
  }
}));

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  // border: '1px solid #000',
  // boxShadow: 24,
  p: '16px',
  borderRadius: 1,
  width: { xs: '60%', sm: '350px' }
};

export default function DriverDetailModal({ isOpen, driverData, onClose }) {
  const classes = useStyles();

  return (
    <Box>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="driver-detail-modal"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: { xs: 16, sm: 18 }, fontWeight: 900 }}>
            Driver Details
          </Typography>

          <Grid container spacing={{ xs: 0, sm: 1 }} mb={3}>
            <Grid item xs={12}>
              <Box
                component="img"
                src={driverData?.image}
                alt={driverData?.name}
                sx={{
                  width: { xs: '80px', sm: '100px' },
                  height: { xs: '80px', sm: '100px' },
                  objectFit: 'contain'
                }}
              />
            </Grid>

            {/* <Grid item xs={12}>
              <img
                src={driverData?.image}
                alt={driverData?.name}
                sx={{ width: '100px', height: '100px', objectFit: 'contain' }}
              />
            </Grid> */}
            <Grid item xs={6}>
              <Typography className={classes.textStyleKey}>Driver Name</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.textStyleValue}>{driverData?.name}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.textStyleKey}>Driver Phone No.</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className={classes.textStyleValue}>{driverData?.phone}</Typography>
            </Grid>
          </Grid>

          {/* <FormControl fullWidth sx={{ mt: 3 }}>
            <TextField
              id="driverName"
              label="Full Name"
              variant="outlined"
              name="driverName"
              defaultValue={driverData?.name}
              InputProps={{
                readOnly: true
              }}
            />
          </FormControl>

          <FormControl fullWidth sx={{ mb: 3, mt: 3 }}>
            <TextField
              id="driverMobile"
              name="phone"
              label="Driver Mobile No"
              type="number"
              defaultValue={driverData?.phone}
              InputProps={{
                maxLength: 2,
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <Button variant="text">+91</Button>
                  </InputAdornment>
                ),
                inputMode: 'numeric',
                pattern: '[0-9]*'
              }}
            />
          </FormControl> */}

          <Button
            onClick={onClose}
            variant="contained"
            size="small"
            type="submit"
            sx={{ display: 'block', margin: '0 0 0 auto' }}
          >
            Done
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
